package org.wordsapp.data

import org.wordsapp.model.*

class WordRepository(private val api: ApiClient) {

    suspend fun fetchWords(): List<Word> {
        return api.getWords().words
    }

    suspend fun updateStatistics(word: Word) {
        api.updateStats(
            rowIndex = word.rowIndex,
            request = UpdateStatsRequest(
                correctAnswers = word.correctAnswers,
                incorrectAnswers = word.incorrectAnswers,
                lastAttemptEpochMs = word.lastAttemptEpochMs,
                streak = word.streak,
                easeFactor = word.easeFactor,
                intervalDays = word.intervalDays,
            ),
        )
    }

    suspend fun checkAuth(): AuthStatusResponse {
        return api.getAuthStatus()
    }

    suspend fun exchangeAppSessionToken(token: String): AuthStatusResponse {
        return api.exchangeAppSessionToken(token)
    }

    suspend fun saveSpreadsheetUrl(url: String): SettingsResponse {
        return api.saveSettings(SettingsRequest(spreadsheetUrl = url))
    }

    suspend fun saveIgnoreDiacritics(value: Boolean): SettingsResponse {
        return api.saveSettings(SettingsRequest(ignoreDiacritics = value))
    }

    suspend fun getSettings(): SettingsResponse {
        return api.getSettings()
    }

    suspend fun logout() {
        api.logout()
    }

    fun getLoginUrl(): String = api.getLoginUrl()
}
